// extracted by mini-css-extract-plugin
export default {"title":"NavbarFooter_title__qHrXF","option":"NavbarFooter_option__aMyTv"};